module.exports = __webpack_public_path__ + "static/media/invite-friends-to-bookings.090b3211.svg";